import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "./Legal.css";

const Disclaimer = () => {
  return (
    <div>
      <Breadcrumbs title="Disclaimer" />
      <div className="container py-16">
        <div className="legal-content">
          <h2>Haftungsausschluss</h2>
          <p>
            Die Informationen, die von &copy; digitale zahnpraxis dr.alshoutaiui ("wir", "uns" oder "unser") auf &copy; digitale zahnpraxis dr.alshoutaiui  (die "Website") bereitgestellt werden, dienen nur allgemeinen Informationszwecken. Alle Informationen auf der Website werden in gutem Glauben bereitgestellt. Wir geben jedoch keine ausdrückliche oder stillschweigende Zusicherung oder Garantie hinsichtlich der Richtigkeit, Angemessenheit, Gültigkeit, Zuverlässigkeit, Verfügbarkeit oder Vollständigkeit der Informationen auf der Website.
          </p>
          <h3>Haftungsausschluss für professionelle Beratung</h3>
          <p>
            Die Website kann und enthält keine rechtlichen Ratschläge. Die rechtlichen Informationen dienen nur allgemeinen Informations- und Bildungszwecken und ersetzen keine professionelle Beratung.
          </p>
          <h3>Affiliate-Haftungsausschluss</h3>
          <p>
            Die Website kann Links zu Affiliate-Websites enthalten, und wir erhalten eine Affiliate-Provision für jeden Kauf, den Sie auf der Affiliate-Website über solche Links tätigen.
          </p>
          <h3>Haftungsausschluss Dritter</h3>
          <p>
            Die Website kann Links zu anderen Websites oder Inhalten enthalten, die Dritten gehören oder von Dritten stammen, oder Links zu Websites und Funktionen in Bannern oder anderer Werbung. Solche externen Links werden von uns nicht untersucht, überwacht oder auf Richtigkeit, Angemessenheit, Gültigkeit, Zuverlässigkeit, Verfügbarkeit oder Vollständigkeit überprüft.
          </p>
          <h3>Einnahmen-Haftungsausschluss</h3>
          <p>
            Jegliche Einnahmen- oder Einkommensdarstellungen sind nur aspirational Statements zu Ihrem Verdienstpotenzial. Der Erfolg eines Unternehmens hängt von vielen Faktoren ab, einschließlich Ihres Engagements, Ihrer Erfahrung und Ihrer Motivation.
          </p>
          <h3>Genauigkeits-Haftungsausschluss</h3>
          <p>
            Während wir uns bemühen, sicherzustellen, dass die Informationen auf dieser Website korrekt sind, garantieren wir nicht deren Vollständigkeit oder Richtigkeit; noch verpflichten wir uns sicherzustellen, dass die Website verfügbar bleibt oder dass das Material auf der Website auf dem neuesten Stand bleibt.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
